{
  "generic": {
    "no": "Nei",
    "yes": "Ja",
    "text": "Tekst "
  },
  "consent": {
    "defaultLabelText": "Ved å sende inn dette skjemaet godtar du vår ",
    "defaultLabelLink": "personvernregler"
  },
  "text": {
    "defaultHeadlineText": "Dette er en overskrift",
    "defaultText": "Dette er en tekstblok",
    "floatingDefaultText": "NY!"
  },
  "button": {
    "submitDefaultText": "Send inn",
    "instagramDefaultText": "Følg oss",
    "defaultText": "Klikk her",
    "closing": "LUKKER..."
  },
  "input": {
    "emailLabel": "E-post",
    "emailPlaceholder": "Skriv inn e-postadressen din",
    "passwordLabel": "Passord",
    "passwordPlaceholder": "Skriv inn passord",
    "nameLabel": "Navn",
    "namePlaceholder": "Skriv inn navnet ditt",
    "firstNameLabel": "Fornavn",
    "firstNamePlaceholder": "Skriv inn fornavn",
    "lastNameLabel": "Etternavn",
    "lastNamePlaceholder": "Skriv inn etternavn",
    "phoneLabel": "Telefon",
    "phonePlaceholder": "Skriv inn telefonnummer",
    "textareaLabel": "Melding",
    "textareaPlaceholder": "Skriv inn meldingen din",
    "regularLabel": "Tekst",
    "regularPlaceholder": "Skriv inn tekst",
    "defaultLabel": "Etikett",
    "defaultPlaceholder": "Plassholder",
    "datePlaceholder": "Velg dato",
    "stepLabel": "Skriv inn spørsmålet ditt her"
  },
  "dropdown": {
    "placeholder": "Velg et alternativ",
    "firstItem": "Alternativ 1",
    "secondItem": "Alternativ 2",
    "chooseCountry": "Land"
  },
  "buttonList": {
    "firstItem": "Alternativ 1",
    "secondItem": "Alternativ 2",
    "option1": "Valg 1",
    "option2": "Valg 2",
    "option3": "Valg 3",
    "subscriptionItem1": "Nyhetsbrev",
    "subscriptionItem2": "Oppdateringer",
    "chooseSubscriptionTopics": "Velg abonnementstemaer",
    "other": "Annet",
    "uncheck-all-label": "Jeg ønsker ikke å motta noen av disse e-postene"
  },
  "rating": {
    "rateLabel": "Vurder oss",
    "npsLabel": "Hvor sannsynlig er det at du vil anbefale oss?",
    "veryUnsatisfied": "Veldig misfornøyd",
    "unsatisfied": "Misfornøyd",
    "neutral": "Nøytral",
    "satisfied": "Fornøyd",
    "loveIt": "Elsker det!",
    "minValueLabel": "Lav",
    "maxValueLabel": "Høy",
    "minValueLabelNps": "Lite sannsynlig",
    "maxValueLabelNps": "Veldig sannsynlig"
  },
  "deadline": {
    "days": "Dager",
    "hours": "Timer",
    "minutes": "Minutter",
    "seconds": "Sekunder"
  },
  "bulletList": {
    "firstItem": "Fordel 1",
    "secondItem": "Fordel 2"
  },
  "discountCode": {
    "copyMessage": "Kopiert til utklippstavle!",
    "fallback": "WELCOME10",
    "textDefault": "Din rabattkode",
    "buttonDefault": "Kopier"
  },
  "share": {
    "buttonText": "Del"
  },
  "common": {
    "label": "Etikett"
  },
  "wcag": {
    "banner": "Reklamebanner",
    "closeButton": "Lukk",
    "submitButton": "Send inn skjema"
  },
  "spinTheWheel": {
    "prizeWonText": "Gratulerer!",
    "prizeWonButtonText": "Gjør krav på premien din",
    "prizeLostText": "Åh nei, så synd! :-(",
    "prizeLostButtonText": "Klikk for å lukke",
    "spinButtonLabel": "SNURR"
  },
  "memory": {
    "resultWonText": "Godt jobbet! Tiden din var {elapsedTime}",
    "resultWonButtonText": "Gjør krav på premien din"
  },
  "stepNavigation": {
    "nextButtonText": "Neste",
    "previousButtonText": "Tilbake",
    "lastButtonText": "Lukk",
    "submitButtonText": "Send inn"
  },
  "defaultRealTimeMessage": {
    "validationError": "Vennligst sjekk formatet på dataene du sendte.",
    "unknownError": "Det oppstod et uventet problem ved innsending.",
    "conflictError": "Denne brukeren finnes allerede.",
    "success": "Skjema sendt."
  }
}
